import {AfterViewInit, Component, OnInit, TemplateRef} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

@Component({
  selector: 'app-image-classification-detail-modal',
  templateUrl: './image-classification-detail-modal.component.html',
  styleUrls: ['./image-classification-detail-modal.component.scss']
})
export class ImageClassificationDetailModalComponent implements AfterViewInit {
  item: any;
  modalConfig: any;
  template: TemplateRef<any>;
  onCancel: Function;

  constructor(private modalRef: BsModalRef) { }

  ngAfterViewInit() {
  }

  cancel() {
    this.onCancel();
    this.modalRef.hide();
  }

}
